import { $definitions, TASK_APPOINTMENT_TYPE_SELECT_ID, TASK_CARE_TEAM_SELECT_ID, TASK_ORDER_STATUS_SELECT_ID, } from 'ziphy-web-shared/basic/entities/notes/definitions';
import { getResourceCode } from '../';
export class TaskExtractor {
    constructor(resource, additional = {}) {
        this._data = resource;
        this.additional = additional;
    }
    get data() {
        return this._data;
    }
    get code() {
        return getResourceCode(this.data.performerType);
    }
    get status() {
        var _a, _b;
        return $definitions.selects.getValue(TASK_ORDER_STATUS_SELECT_ID, ((_a = this.data) === null || _a === void 0 ? void 0 : _a.status) || ((_b = this.additional) === null || _b === void 0 ? void 0 : _b.status));
    }
    get date() {
        return this.data.occurrenceDate;
    }
    get careTeam() {
        return $definitions.selects.getValue(TASK_CARE_TEAM_SELECT_ID, this.data.careTeam);
    }
    get appointmentType() {
        return $definitions.selects.getValue(TASK_APPOINTMENT_TYPE_SELECT_ID, this.data.appointmentType);
    }
    get hasDevice() {
        return this.data.patientHasTelehealthDevice;
    }
    get hasSkills() {
        return this.data.patientHasTelehealthSkills;
    }
    get note() {
        return this.data.note;
    }
}
export class TaskReferralSpecialistExtractor extends TaskExtractor {
}
export class TaskReferralServiceExtractor extends TaskExtractor {
}
export class TaskRequestAppointmentExtractor extends TaskExtractor {
}
export class TaskRequestAppointmentPcpExtractor extends TaskExtractor {
}
export class TaskOrderLabExtractor extends TaskExtractor {
}
export class TaskOrderImagingExtractor extends TaskExtractor {
}
